import Home from "../components/home/Home";
import { Routes, Route } from "react-router-dom";
import BlogList from "../components/blog/BlogList";
import Aboutus from "../components/aboutus/Aboutus";
import SeoManager from "../components/seo/SeoManager";
import NewsList from "../components/newsList/NewsList";
import BlogDetails from "../components/blog/BlogDetails";
import NewsDetails from "../components/news/NewsDetails";
import Contactus from "../components/contactus/Contactus";
import Accolades from "../components/accolades/Accolades";
import VideosList from "../components/videosList/VideosList";
import Specialties from "../components/specialties/Specialties";
import DoctorsList from "../components/doctorsList/DoctorsList";
import TermsServices from "../components/policies/TermsServices";
import PrivacyPolicy from "../components/policies/PrivacyPolicy";
import DoctorProfile from "../components/doctorProfile/DoctorProfile";
import SpecialitiesList from "../components/specialitiesList/SpecialitiesList";
import HealthCheckupList from "../components/healthCheckupList/HealthCheckupList";
// import MasterHealthCheckup from "../components/masterHealthCheckup/MasterHealthCheckup";
import InternationalPatientPage from "../components/internationalPatient/InternationalPatientPage";

const AppRoutes = () => {
  return (
    <>
    <SeoManager />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<Aboutus />} />
      <Route path="/newslist" element={<NewsList />} />
      <Route path="/bloglist" element={<BlogList />} />
      <Route path="/accolades" element={<Accolades />} />
      <Route path="/contact-us" element={<Contactus />} />
      <Route path="/videoslist" element={<VideosList />} />
      <Route path="/doctorslist" element={<DoctorsList />} />
      <Route path="/doctor/:slug" element={<DoctorProfile />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-services" element={<TermsServices />} />
      <Route path="/specialties/:slug" element={<Specialties />} />
      <Route path="/blog-details/:slug" element={<BlogDetails />} />
      <Route path="/news-details/:slug" element={<NewsDetails />} />
      <Route path="/specialitieslist" element={<SpecialitiesList />} />
      <Route path="/healthcheckuplist" element={<HealthCheckupList />} />
      <Route path="/international" element={<InternationalPatientPage />} />
      {/* <Route path="/master-health-checkup" element={<MasterHealthCheckup />} /> */}
    </Routes>
    </>
  );
};

export default AppRoutes;
